import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import { GridConstants } from '../../constants/Grid';
import { PandoraTypes, SourceTypes } from '../../constants/SourceTypes';
import { getInDomain } from '../../domains/externalUtils';
import { getArt, getDominantColor } from '../../lib/ArtUtils';
import { getAnnotationsById } from '../../lib/EntityUtils';
import { isRadioOnly, isUnavailable } from '../../lib/RightsUtils';
import { getSourceCardMenuItems } from '../../lib/SourceCardUtils';
import { formatTime } from '../../lib/TimeUtils';

import CatalogRowItem from './CatalogRowItem';

class TrackRowItem extends React.Component {
  static propTypes = {
    componentName: PropTypes.string,
    feedbackId: PropTypes.string,
    id: PropTypes.string,
    isNegativeFeedback: PropTypes.bool, // cspell:disable-line
    isOwnStation: PropTypes.bool,
    pandoraType: PropTypes.string,
    stationId: PropTypes.string,
  };

  static defaultProps = {
    pandoraType: PandoraTypes.SONG,
  };

  render() {
    return <CatalogRowItem {...this.props} />;
  }
}

export function mapStateToProps(state, ownProps) {
  const props = {};
  const details = getAnnotationsById(state, ownProps.id);
  props.blankItem = !details;
  if (details) {
    props.mainTextUrl = details.get('shareableUrlPath');
    props.mainText = details.get('name');
    props.secondText = details.get('artistName');
    props.rightColChild = formatTime(details.get('duration'));
    props.isPlayingCurrently =
      getInDomain('playback.utils.isTrackPlayingCurrently', false)(state, ownProps.id) &&
      (getInDomain('playlist.utils.getCurrentPlaylistType')(state) ===
        SourceTypes.COLLECTED_TRACKS ||
        ownProps.sourceType === SourceTypes.STATION_THUMB_UP);
    props.sourceCardMenuItems = getSourceCardMenuItems({
      albumId: details.get('albumId'),
      pandoraId: ownProps.id,
      pandoraType: PandoraTypes.SONG,
      shareParentSource: {
        shareParentSourceId: ownProps.stationId ? ownProps.stationId : details.get('albumId'),
        shareParentSourceType: ownProps.stationId ? PandoraTypes.STATION : PandoraTypes.ALBUM,
      },
      state,
      stationData: ownProps.stationId && {
        feedbackId: ownProps.feedbackId,
        isOwned: ownProps.isOwnStation,
        // cspell:disable-next-line
        isPositive: !ownProps.isNegativeFeedback,
      },
      stationId: ownProps.stationId,
    });

    const artist = getAnnotationsById(state, details.get('artistId'));

    if (ownProps.artistUrlPath || artist) {
      props.secondTextUrl = ownProps.artistUrlPath || artist.get('shareableUrlPath');
    }
    props.imgUrl = getArt(details, GridConstants.GRID_ITEM_IMAGE_SIZE, state);
    props.isRadioOnly = isRadioOnly(details);
    props.isUnavailable = isUnavailable(details);
    props.isExplicit = getInDomain('catalog.utils.isExplicit')(details);
    props.isClean = getInDomain('catalog.utils.isClean')(details);
    props.dominantColor = getDominantColor(details);
  }
  return props;
}

export default connect(mapStateToProps)(TrackRowItem);
